<ccl-route-tabs>
    <ccl-route-tab tabTitle="Highlighted" route="highlighted" [hidden]="!(catalogLayoutConfig.listType == 'magazine')">
    </ccl-route-tab>
    <ccl-route-tab
        tabTitle="Promoted"
        route="promoted"
        [hidden]="!(catalogLayoutConfig.listType == 'magazine' || catalogLayoutConfig.listType == 'promoted')"
    >
    </ccl-route-tab>
    <ccl-route-tab tabTitle="General" route="general"> </ccl-route-tab>
</ccl-route-tabs>
<ccl-section-wrapper>
    <ccl-content-section>
        <router-outlet></router-outlet>
    </ccl-content-section>
</ccl-section-wrapper>
